module.exports = __webpack_public_path__ + "img/up.96eb0e5.png";